import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Container, Card, Header } from "semantic-ui-react";

import ProjectWizardConfigCard from "../../components/projectWizard/ProjectWizardConfigCard.jsx";

import { OPERATIONS } from "../../constants/operations.js";
import { AT_TYPES } from "../../constants/entity.js";

import endpointSelector from "../../state/reducers/endpoints/endpointSelector.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ProjectWizardConfigSelector extends PureComponent {
  static propTypes = {
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "project_wizard_config_selector"
  };

  // -- RENDER -- //

  render() {
    const { copyKey, copy } = this.props;

    return (
      <Container className="main-responsive">
        <Header as="h3">{copy(`${copyKey}.title`)}</Header>

        <p>{copy(`${copyKey}.description`)}</p>

        <Card.Group>
          <ProjectWizardConfigCard
            configId="born-in-the-cloud/details"
            icon="sitemap"
            copyKey={`${copyKey}.born_in_the_cloud`}
          />
          <ProjectWizardConfigCard
            configId="linux-burst-render/details"
            icon="server"
            copyKey={`${copyKey}.linux_burst_render`}
          />
        </Card.Group>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  createProjectAvailability: endpointSelector.selectOperationAvailability(
    state
  )(AT_TYPES.PROJECT, OPERATIONS.CREATE),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ProjectWizardConfigSelector);
